import { useState, type ReactNode } from 'react';
import './components.css';

export function Tooltip({
  children,
  content,
  side = 'top',
}: {
  children: ReactNode;
  content: ReactNode;
  side?: 'top' | 'bottom' | 'right' | 'left';
}) {
  const [show, setShow] = useState(false);
  return (
    <span
      className="iris-tooltip-host"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && <span className={`iris-tooltip side-${side}`}>{content}</span>}
    </span>
  );
}
